import { createFileRoute } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset.tsx";
import PlanTable from "@/app/(authenticated)/$merchantId/plans/_components/plan-table.tsx";

export const Route = createFileRoute("/(authenticated)/$merchantId/plans/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ContainerInset
      title="Plans"
      breadcrumbs={[
        {
          title: "Recurring Plans",
          href: "/plans",
        },
      ]}
    >
      <PlanTable />
    </ContainerInset>
  );
}
